import { render, staticRenderFns } from "./IncomeTaxCalculator.vue?vue&type=template&id=4a4f8612&scoped=true"
import script from "./IncomeTaxCalculator.vue?vue&type=script&lang=ts"
export * from "./IncomeTaxCalculator.vue?vue&type=script&lang=ts"
import style0 from "./IncomeTaxCalculator.vue?vue&type=style&index=0&id=4a4f8612&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a4f8612",
  null
  
)

export default component.exports